import React from 'react';
import ExpenseList from './ExpenseList';

class ExpensePage extends React.Component {
  render() {
    return (
      <div>
        <ExpenseList />
      </div>
    );
  }
}

export default ExpensePage;



// WEBPACK FOOTER //
// ./src/components/expense/ExpensePage.js